<pp-delete-button
  [ppDisabled]="ppDisabled"
  [ppId]="buttonId"
  (ppAction)="showDeleteShareModal()"
></pp-delete-button>
